<div class="upload-wrapper">
  <!-- Drop zone (fixed height, always visible) -->
  <div
    [ngClass]="
      isMulti ? 'custom-dropzone' : 'custom-dropzone custom-single-dropzone'
    "
    ngx-dropzone
    [accept]="acceptedFileTypes"
    [maxFileSize]="MAX_SIZE"
    (change)="onSelect($event)"
    [disabled]="disabled"
    [multiple]="isMulti"
  >
    <ngx-dropzone-label>
      <div class="drag-dorp-label">
        <div class="icon-upload">
          <mat-icon fontSet="material-icons-outlined">file_upload</mat-icon>
        </div>

        <span class="upload-inst"
          ><strong>Click to upload </strong>or drag and drop</span
        >
        <span class="upload-size">PDF, DOCX (max. {{ maxFiles }} files at a time)</span>
        @if (activeFileCount > 0) {
          <span class="file-counter">{{ activeFileCount }} of {{ maxFiles }} files selected</span>
        }
      </div>
    </ngx-dropzone-label>
  </div>

  <!-- Clear buttons toolbar (only show when files exist) -->
  @if (files.length > 0) {
    <div class="clear-toolbar">
      <div class="left-buttons">
        <button
          mat-stroked-button
          color="warn"
          (click)="clearAll(); $event.stopPropagation()"
          matTooltip="Remove all files"
          class="clear-btn">
          <mat-icon>clear_all</mat-icon>
          Clear All
        </button>

        @if (hasSuccessfulUploads()) {
          <button
            mat-stroked-button
            color="primary"
            (click)="clearSuccessful(); $event.stopPropagation()"
            matTooltip="Remove successfully uploaded files"
            class="clear-btn">
            <mat-icon>check_circle</mat-icon>
            Clear Successful
          </button>
        }
      </div>

      <div class="upload-status-summary">
        <span class="status-badge queued-badge" matTooltip="Queued for upload">
          <mat-icon>schedule</mat-icon> {{ queuedCount }} queued
        </span>
        <span class="status-badge pending-badge" matTooltip="Currently uploading">
          <mat-icon>hourglass_empty</mat-icon> {{ pendingCount }} uploading
        </span>
        <span class="status-badge success-badge" matTooltip="Successfully uploaded">
          <mat-icon>check_circle</mat-icon> {{ successCount }} uploaded
        </span>
        <span class="status-badge failed-badge" matTooltip="Failed to upload">
          <mat-icon>error</mat-icon> {{ failedCount }} failed
        </span>
      </div>

      <div class="right-buttons">
        <app-submit-button
          [disabled]="submitDisabled"
          [loading]="submitLoading"
          [text]="submitText"
          (submit)="onSubmit.emit()"
        >
        </app-submit-button>
      </div>
    </div>
  }

  <!-- File list (scrollable, separate from drop zone) -->
  <div class="file-list-container">
    @for (fileDetails of files; track fileDetails) {
      <div class="file-item" [ngClass]="getStatusClass(fileDetails.uploadStatus)">
        <!-- Status Icon -->
        <div class="file-status-icon">
          @if (fileDetails.uploadStatus == uploadStatus.QUEUED) {
            <mat-icon class="status-icon queued-icon">schedule</mat-icon>
          } @else if (fileDetails.uploadStatus == uploadStatus.PENDING) {
            <mat-icon class="status-icon pending-icon spin">hourglass_empty</mat-icon>
          } @else if (fileDetails.uploadStatus == uploadStatus.SUCCESS) {
            <mat-icon class="status-icon success-icon">check_circle</mat-icon>
          } @else if (fileDetails.uploadStatus == uploadStatus.ERROR) {
            <mat-icon class="status-icon error-icon">error</mat-icon>
          }
        </div>

        <!-- File Info (single line) -->
        <div class="file-info">
          <mat-icon fontSet="material-icons-outlined" class="file-icon">insert_drive_file</mat-icon>
          <span class="file-name-text">{{ fileDetails.file.name }}</span>
          <span class="file-size">{{ (fileDetails.file.size / 1024 / 1024).toFixed(2) }} MB</span>
        </div>

        <!-- Progress bar for pending uploads (full width below) -->
        @if (fileDetails.uploadStatus == uploadStatus.PENDING) {
          <div class="progress-container">
            <mat-progress-bar mode="indeterminate" class="upload-progress"></mat-progress-bar>
          </div>
        }

        <!-- Action Buttons -->
        <div class="file-actions">
          <!-- Cancel button (only for pending uploads) -->
          @if (fileDetails.uploadStatus == uploadStatus.PENDING) {
            <button
              mat-icon-button
              (click)="cancelUpload(fileDetails); $event.stopPropagation()"
              matTooltip="Cancel upload"
              class="action-btn cancel-btn">
              <mat-icon>cancel</mat-icon>
            </button>
          }

          <!-- Retry button (only for failed uploads) -->
          @if (fileDetails.uploadStatus == uploadStatus.ERROR) {
            <button
              mat-icon-button
              (click)="retryUpload(fileDetails); $event.stopPropagation()"
              matTooltip="Retry upload"
              class="action-btn retry-btn">
              <mat-icon>refresh</mat-icon>
            </button>
          }

          <!-- Remove button (always visible) -->
          <button
            mat-icon-button
            (click)="onRemove(fileDetails); $event.stopPropagation()"
            matTooltip="Remove file"
            class="action-btn remove-btn">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    }
  </div>
</div>
